import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FundOverviewPageComponent} from "./fund-overview-page/fund-overview-page.component";
import {FundDetailsPageComponent} from "./fund-details-page/fund-details-page.component";
import {SharedModule} from "../shared/shared.module";
import {MatCardModule} from "@angular/material/card";
import {MatTableModule} from "@angular/material/table";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatListModule} from "@angular/material/list";
import {MatChipsModule} from "@angular/material/chips";
import {FundSellerPositionComponent} from "./fund-details-page/fund-seller-position/fund-seller-position.component";
import {MatIconModule} from "@angular/material/icon";
import {FundDetailsComponent} from "./fund-details-page/fund-details/fund-details.component";
import {FundUndrawnValuationComponent} from "./fund-details-page/fund-undrawn-valuation/fund-undrawn-valuation.component";
import {FundPartnershipInvestmentsComponent} from "./fund-details-page/fund-partnership-investments/fund-partnership-investments.component";
import {FundTreemapActualComponent} from "./fund-details-page/fund-treemap-actual/fund-treemap-actual.component";
import {FundReturnSummaryComponent} from "./fund-details-page/fund-return-summary/fund-return-summary.component";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FundNewDialogComponent} from "./fund-new-dialog/fund-new-dialog.component";
import {MatDialogModule} from "@angular/material/dialog";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatSelectModule} from "@angular/material/select";
import {FundValuationManageDialogComponent} from "./fund-details-page/fund-valuation-manage-dialog/fund-valuation-manage-dialog.component";
import {FundInvestmentNewDialogComponent} from "./fund-details-page/fund-investment-new-dialog/fund-investment-new-dialog.component";
import {FundReportNewDialogComponent} from "./fund-details-page/fund-report-new-dialog/fund-report-new-dialog.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {FundCashflowsComponent} from "./fund-details-page/fund-cashflows/fund-cashflows.component";
import {MatTabsModule} from "@angular/material/tabs";
import {MatTooltipModule} from "@angular/material/tooltip";
import {FundCashflowTableComponent} from "./fund-details-page/fund-cashflows/fund-cashflow-table/fund-cashflow-table.component";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {FundReportDetailsComponent} from "./fund-details-page/fund-report-details/fund-report-details.component";
import {FundCashflowsGraphComponent} from "./fund-details-page/fund-cashflows-graph/fund-cashflows-graph.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {
    FundCurrentAndRealizedInvestmentsComponent
} from "./fund-details-page/fund-partnership-investments/fund-current-and-realized-investments/fund-current-and-realized-investments.component";
import {MatSortModule} from "@angular/material/sort";
import {MatPaginatorModule} from "@angular/material/paginator";
import {BASE_PATH} from "./generated-sources/api";
import {SearchModule} from "../search/search.module";
import {FundReportMergeTargetDialogComponent} from "./fund-details-page/fund-report-merge-target-dialog/fund-report-merge-target-dialog.component";
import {AssetDetailsDialogComponent} from "./fund-details-page/fund-partnership-investments/asset-details-dialog/asset-details-dialog.component";
import {AssetModule} from "../asset/asset.module";
import {GeneralPartnerNewDialogComponent} from "./general-partner-new-dialog/general-partner-new-dialog.component";
import {GeneralPartnerOverviewPageComponent} from "./general-partner/general-partner-overview-page/general-partner-overview-page.component";
import {GeneralPartnerDetailsPageComponent} from "./general-partner/general-partner-details-page/general-partner-details-page.component";
import {GeneralPartnerDetailsComponent} from "./general-partner/general-partner-details-page/general-partner-details/general-partner-details.component";
import {FundTableComponent} from "./components/fund-table/fund-table.component";
import {MatSliderModule} from "@angular/material/slider";
import {MatMenuModule} from "@angular/material/menu";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {ContextMenuComponent} from "../shared/components/context-menu/context-menu.component";
import {FundValuationDescriptionDialogComponent} from "./fund-details-page/fund-valuation-description-dialog/fund-valuation-description-dialog.component";
import {FundValuationOverviewPageComponent} from "./fund-valuation-overview-page/fund-valuation-overview-page.component";
import {FundReportCopyDialogComponent} from "./fund-details-page/fund-copy-workflow-stepper/fund-report-copy-dialog/fund-report-copy-dialog.component";
import {FundValuationCopyDialogComponent} from "./fund-details-page/fund-copy-workflow-stepper/fund-valuation-copy-dialog/fund-valuation-copy-dialog.component";
import {MatRadioModule} from "@angular/material/radio";
import {AssetValuationCopyDialogComponent} from "./fund-details-page/fund-copy-workflow-stepper/asset-valuation-copy-dialog/asset-valuation-copy-dialog.component";
import {FundCopyWorkflowStepperComponent} from "./fund-details-page/fund-copy-workflow-stepper/fund-copy-workflow-stepper.component";
import {MatStepperModule} from "@angular/material/stepper";
import {FundManagementFeeSettingsDialogComponent} from "./fund-details-page/fund-management-fee-settings-dialog/fund-management-fee-settings-dialog.component";
import {FundTopDownValuationComponent} from "./fund-details-page/fund-top-down-valuation/fund-top-down-valuation.component";
import {NetCurrentAssetDialogComponent} from "./fund-details-page/net-current-asset-dialog/net-current-asset-dialog.component";
import {FundValuationDeferralDialogComponent} from "./fund-details-page/fund-valuation-deferral-dialog/fund-valuation-deferral-dialog.component";
import { RouterModule } from "@angular/router";
import { FundAiSetupModule } from "../fund-ai-setup/fund-ai-setup.module";
import { AlgorithmicDmvModule } from "../algorithmic-dmv/algorithmic-dmv.module";

@NgModule({
    declarations: [
        FundOverviewPageComponent,
        FundDetailsPageComponent,
        FundSellerPositionComponent,
        FundDetailsComponent,
        FundUndrawnValuationComponent,
        FundPartnershipInvestmentsComponent,
        FundTreemapActualComponent,
        FundCashflowsGraphComponent,
        FundReturnSummaryComponent,
        FundNewDialogComponent,
        FundValuationManageDialogComponent,
        FundInvestmentNewDialogComponent,
        FundReportNewDialogComponent,
        FundCashflowsComponent,
        FundCashflowTableComponent,
        FundReportDetailsComponent,
        FundCurrentAndRealizedInvestmentsComponent,
        FundReportMergeTargetDialogComponent,
        AssetDetailsDialogComponent,
        GeneralPartnerNewDialogComponent,
        GeneralPartnerOverviewPageComponent,
        GeneralPartnerDetailsPageComponent,
        GeneralPartnerDetailsComponent,
        FundTableComponent,
        FundValuationDescriptionDialogComponent,
        FundValuationOverviewPageComponent,
        FundReportCopyDialogComponent,
        FundValuationCopyDialogComponent,
        AssetValuationCopyDialogComponent,
        FundCopyWorkflowStepperComponent,
        FundManagementFeeSettingsDialogComponent,
        FundTopDownValuationComponent,
        NetCurrentAssetDialogComponent,
        FundValuationDeferralDialogComponent
    ],
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        FundAiSetupModule,
        AlgorithmicDmvModule,
        MatButtonModule,
        MatCardModule,
        MatChipsModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatSidenavModule,
        MatTableModule,
        ReactiveFormsModule,
        SharedModule,
        MatDialogModule,
        MatDatepickerModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatTabsModule,
        MatTooltipModule,
        MatAutocompleteModule,
        MatExpansionModule,
        MatSortModule,
        MatPaginatorModule,
        SearchModule,
        AssetModule,
        MatSliderModule,
        MatMenuModule,
        MatCheckboxModule,
        MatRadioModule,
        MatStepperModule,
        ContextMenuComponent,
    ],
    exports: [
        FundTableComponent,
        FundReturnSummaryComponent,
        FundCashflowsComponent,
        FundCashflowsGraphComponent
    ],
    providers: [
        {provide: BASE_PATH, useValue: ".."}
    ]
})
export class FundModule {
}
